/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SpecialityOrganizationInstance } from '../../models/speciality-organization-instance';

export interface AnonymousSpecialityInstancesGet$Params {
  systemSpecialityGroupId?: string;
}

export function anonymousSpecialityInstancesGet(http: HttpClient, rootUrl: string, params?: AnonymousSpecialityInstancesGet$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<SpecialityOrganizationInstance>>> {
  const rb = new RequestBuilder(rootUrl, anonymousSpecialityInstancesGet.PATH, 'get');
  if (params) {
    rb.query('systemSpecialityGroupId', params.systemSpecialityGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<SpecialityOrganizationInstance>>;
    })
  );
}

anonymousSpecialityInstancesGet.PATH = '/Anonymous/SpecialityInstances';
